import { createAdminClient } from '@meteor/app-core-api/admin-client';

export let adminClient = createAdminClient({
  host: import.meta.env.VITE_APP_ADMIN_API_HOST!
});
